import cx from "classnames";
import React from "react";
import { DOMPurifyWithTargetBlankHook } from "component-library";
import { dataTestIds } from "data-testids";
import "./BreakdownText.scss";

export interface IBreakdownTextProps {
  keepFormatting?: boolean;
  isPrintView?: boolean;
}

const BreakdownText: React.FC<React.PropsWithChildren<IBreakdownTextProps>> = (
  props
) => {
  const isChildrenString = typeof props.children === "string";

  return (
    <div
      className={cx("c-breakdown-text", {
        "c-breakdown-text--keep-formatting": props.keepFormatting,
        "c-breakdown-text--print": props.isPrintView,
      })}
      data-testid={dataTestIds.nuLinkBoard["Breakdown.BreakdownText.text"]}
    >
      {isChildrenString ? (
        <span
          className="rich-text"
          dangerouslySetInnerHTML={{
            __html: DOMPurifyWithTargetBlankHook.sanitize(
              props.children as string
            ),
          }}
        />
      ) : (
        props.children
      )}
    </div>
  );
};

export default BreakdownText;
